module.exports = __webpack_public_path__ + "static/media/virtual-sprite-2x.9e07f907.png";